import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterNamePipe',
  pure: true
})
export class FilterNamePipe implements PipeTransform {

  transform(items: any[], searchTerm: any, searchBy: string): any[] {
    if (!searchTerm) {
      return items;
    }
    // when there is partial or full match of the search term
    return items.filter(item => {
      const currentItem = item[searchBy];
      return (currentItem.toString().toLowerCase()).trim() === (searchTerm.trim().toLowerCase()).trim();
    });
  }

}
